export enum ADDRESS_INPUT_TYPES {
  MANUAL = "MANUAL",
  AUTOCOMPLETE = "AUTOCOMPLETE",
}

export const AUTOCOMPLETE_DELAY_MILLISECOND = 300;
